import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import conf from "../config";
class WASLCompanyStore {
  WASLCompanyArray = [];
  WASLCompanyStatus = [];
  inquiryStatus = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      WASLCompanyArray: observable,

      inquiryStatus: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getCompanyInfo: action,
      getWASLCompanyStatus: action,
      deleteRecord: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ searchField, offset, limit, UcompanyId }) {
    this.loading = true;

    var postData = {
      searchField: searchField,
      UcompanyId: UcompanyId,
      offset: offset,
      limit: limit,
    };

    var base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=companyList", "postData=" + base64Input);

    this.WASLCompanyArray = response?.data?.data?.company;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async registerCompany(data) {
    var postData = data;

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=registerCompany", "postData=" + base64Input);

    return response;
  }

  async getCompanyInfo(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=getCompanyInfo", "postData=" + base64Input);

    return response.data.data;
  }

  async exportExcel(getData) {
    // window.location.href = conf.baseURL + "index.php?c=company&a=exportCompanyExcel&dType=" +getData.dType+ '&isadmin='+getData.isadmin+ '&cid='+getData.cid+ '&cType='+getData.cType +'&cName='+getData.cName + '&email='+getData.email+ '&colList='+getData.colList
    window.location.href =
      conf.baseURL +
      "index.php?c=wasl&a=exportwaslcompanyexcel&cid=" +
      getData.cid +
      "&UcompanyId=" +
      getData.UcompanyId +
      "&colList=" +
      getData.colList +
      "&searchField=" +
      getData.searchField;
  }

  async deleteRecord({ Id, companyId, waslkey, userId }) {
    var postData = {
      waslId: Id,
      companyId: companyId,
      waslKey: waslkey,
      userId: userId,
    };

    console.log(postData, "posytyy");
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=wasl&a=deleteCompany", "postData=" + base64Input);
    return response;
  }

  async getWASLCompanyStatus(record) {
    var postData = { Id: record.Id, waslKey: record.waslKey };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=wasl&a=getwaslcompanystatus",
        "postData=" + base64Input
      );
    if (response?.data?.data) {
      this.inquiryStatus = JSON.parse(response?.data?.data);
    } else {
      this.WASLCompanyStatus = response?.data?.errors[0][0];
    }

    return response?.data?.data;
  }
}

export default WASLCompanyStore;
